<template><!--
  無効化の確認。

  **「削除」と書かない。**行は消えない。過去の勤務表や経費には
  この人の名前が出続けるし、あとで有効に戻せる。
  一覧のボタンもサーバの文言も、前から「無効」と言っている。
  ここだけが「削除」で、言っていることがずれていた。
-->
<transition name="modal">
  <!--
    閉じるのは背景を押したときだけ。中のどこを押しても閉じていたので、
    「無効にする」を押した瞬間に小窓が消え、断られた理由を読めなかった。
    背景は wrapper が覆っているので、両方で受ける。
  -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal-wrapper" @click.self="$emit('close')">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol>
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>無効化の確認</strong></a>
              <CCardText><strong>以下の利用者を無効にしますか？</strong></CCardText>
              <CCardText class="text-muted" style="font-size: 13px">
                ログインできなくなり、承認者などの選択肢にも表示されなくなります。
                <b>過去の勤務表・経費には名前が残ります。</b>
                あとで「無効な利用者」から有効に戻せます。
              </CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>社員番号</strong></a><br>
                  {{ val.employee_id }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>氏名</strong></a><br>
                  {{ val.name }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>権限グループ</strong></a><br>
                  {{ roleLabel }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給日数</strong></a><br>
                  {{ val.paid_days }}<block v-if="val.paid_days">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>代休日数</strong></a><br>
                  {{ val.comp_days }}<block v-if="val.comp_days">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>今期有休消化日数</strong></a><br>
                  {{ val.paid_days_used }}<block v-if="val.paid_days_used">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給付与月</strong></a><br>
                  {{ val.paid_days_add }}<block v-if="val.paid_days_add">月</block><block v-else></block>
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <ActionResultMessage :text="error" type="danger" />
        <CRow>
          <CCol sm="10">
            <button @click="$emit('close')" :disabled="loading" class="btn btn-secondary btn-sm">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'無効にする'"
              :loading="loading"
              class="btn btn-danger"
              @click="$emit('delete')"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
import ActionResultMessage from '../components/ActionResultMessage.vue'
export default {
  components: { SaveButton, ActionResultMessage },
  name: 'DeleteModal',
  data () {
    return {
    }
  },
  props: {
    val: Object,
    loading: Boolean,
    // 無効にするのを断られた理由。小窓を閉じずにここへ出す。
    error: { type: String, default: '' }
  },
  computed: {
    /**
     * 一覧の「権限グループ」の列と同じ中身（role_names）を出す。
     * 前は旧3権限の種別名（authority_name）を「ユーザ種別」として出していたが、
     * 一覧の行にその値は無く、いつも空だった（2026-10-03 画面で確かめた）。
     */
    roleLabel () {
      const names = this.val && Array.isArray(this.val.role_names) ? this.val.role_names : []
      return names.length ? names.join('、') : '未設定'
    }
  }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
</style>
